var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail_content"},[_c('div',{staticClass:"detail_label_flex"},[_vm._v("\n    "+_vm._s(_vm.titleLabel)+"\n    "),_c('input',{staticClass:"tenant_checkbox",class:_vm.nameValue,attrs:{"type":"checkbox","name":_vm.nameValue,"checked":""}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-229d847e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/masterPanel/masterView/CorporationView/corporationComponents/checkBoxSection.vue
// module id = null
// module chunks = 